var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcluir(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_2087",
    "data-name": "Grupo 2087",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.176,
    height: 27.176,
    viewBox: "0 0 27.176 27.176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1825",
    "data-name": "Ret\\xE2ngulo 1825",
    width: 27.176,
    height: 27.176,
    fill: "#0078d9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2086",
    "data-name": "Grupo 2086",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5541",
    "data-name": "Caminho 5541",
    d: "M13.589,27.176h0A13.588,13.588,0,0,1,3.98,3.98,13.588,13.588,0,1,1,23.2,23.2a13.5,13.5,0,0,1-9.607,3.98m0-25.655a12.067,12.067,0,0,0-8.532,20.6,11.989,11.989,0,0,0,8.533,3.534h0a12.067,12.067,0,0,0,8.531-20.6,11.988,11.988,0,0,0-8.532-3.534",
    fill: "#0078d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5542",
    "data-name": "Caminho 5542",
    d: "M129.529,130.29a.758.758,0,0,1-.538-.223l-9.936-9.936a.761.761,0,0,1,1.076-1.076l9.936,9.936a.761.761,0,0,1-.538,1.3",
    transform: "translate(-110.973 -110.974)",
    fill: "#0078d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5543",
    "data-name": "Caminho 5543",
    d: "M119.592,130.29a.761.761,0,0,1-.538-1.3l9.936-9.936a.761.761,0,0,1,1.076,1.076l-9.936,9.936a.758.758,0,0,1-.538.223",
    transform: "translate(-110.973 -110.974)",
    fill: "#0078d9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcluir);
export default __webpack_public_path__ + "static/media/excluir.67c92a251dfba49aaf3f4d2d79272624.svg";
export { ForwardRef as ReactComponent };